<template>
  <section>
    <v-card class="p-p-0 p-pl-lg-3 p-mb-5" flat>
      <v-layout mb-3 align-start justify-space-between row>
        <v-toolbar-title>Enlaces</v-toolbar-title>
        <Button
          label="Agregar"
          type="primary"
          icon="pi pi-plus"
          @click="openDialog()"
        />
      </v-layout>
      <DataTable :value="links" :autoLayout="true">
        <Column field="nombre" header="Nombre" />
        <Column field="url" header="URL" />
        <Column>
          <template #header>
            <div class="text-right">Acciones</div>
          </template>
          <template #body="slotProps">
            <div class="text-right">
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning"
                @click="confirmDelete(slotProps.data.id)"
                v-tooltip.top="'Eliminar'"
              />
            </div>
          </template>
        </Column>
        <template #empty> No hay enlaces registrados. </template>
      </DataTable>
    </v-card>
    <Dialog
      :visible.sync="showDialog"
      :style="{ width: '450px' }"
      header="Agregar Enlace"
      :modal="true"
      class="p-fluid"
    >
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit(submitForm)">
          <base-input
            v-model="link.nombre"
            rules="required|min:3"
            label="Nombre"
            name="Nombre"
            type="text"
          />
          <base-input
            v-model="link.url"
            rules="required|min:3"
            label="URL"
            name="URL"
            type="text"
          />
          <div class="p-d-flex">
            <Button
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-text mx-2"
              type="button"
              @click="showDialog = false"
            />
            <Button
              class="mx-2"
              label="Guardar"
              icon="pi pi-check"
              type="submit"
            />
          </div>
        </form>
      </ValidationObserver>
    </Dialog>
  </section>
</template>

<script>
import linkService from "@/services/axios/links.service";
export default {
  props: ["links", "lessonId"],
  data() {
    return {
      showDialog: false,
      file: null,
      fileTypes: [],
      link: {
        nombre: "",
        url: "",
        link_type: 0
      },
    };
  },
  methods: {
    openDialog() {
      this.file = {};
      this.showDialog = true;
    },
    submitForm() {
      linkService.save({ ...this.link, lesson_id: this.lessonId }).then(
        ({ data }) => {
          this.showDialog = false;
          this.$emit("setData", data);
          this.$swal({
            text: "Enlace creado con éxito",
            icon: "success",
          });
        },
        (error) => {
          this.$swal({
            title: "Error",
            text: error.response.data.error,
            icon: "error",
          });
        }
      );
    },
    confirmDelete(id) {
      this.$confirm.require({
        message: "¿Estás seguro de realizar esta acción?",
        header: "Confirmación",
        icon: "pi pi-info-circle",
        acceptLabel: "Si",
        acceptClass: "p-button-danger",
        accept: () => this.deleteLink(id),
        reject: () => {},
      });
    },
    deleteLink(id) {
      linkService.delete(id).then(
        ({ data }) => {
          this.$emit("setData", data);
          this.$swal({
            text: "Enlace eliminado con éxito",
            icon: "success",
          });
        },
        (error) => {
          this.$swal({
            icon: "error",
            title: "Error",
            text: error.response.data.error,
          });
        }
      );
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Leccion/Links.vue